// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { determineIcon } from './ProgressStatus.utils';

export type Props = {
  disabled?: boolean,
  variant: 'notStarted' | 'submitted' | 'completed',
};

const ProgressStatus = ({ disabled, variant }: Props) => {
  const Icon = determineIcon(variant);
  const notStarted = disabled || variant === 'notStarted';
  return (
    <Typography
      variant={'labelSmall'}
      color={notStarted ? 'action.disabled' : 'success.main'}
      alignItems={'center'}
      display={'flex'}
    >
      <FormattedMessage id={`app.progressStatus.${variant}`} />
      <Icon
        sx={{ marginLeft: 0.5 }}
        color={notStarted ? 'disabled' : 'success'}
        fontSize={'xSmall'}
      />
    </Typography>
  );
};

ProgressStatus.defaultProps = {
  variant: 'completed',
};

export default ProgressStatus;
